import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Verify that the Operator is running and ready`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=aiops-starter-installation" target="_blank">🌏 Documentation for the Task: Online starter installation of CP4AIOPS</a>
    <p>{`Check that the Operator is running and that you can continue with the next chapter to install CP4AIOPS. You can do this by listing the `}<inlineCode parentName="p">{`ClusterServiceVersions`}</inlineCode>{` (csv) for the `}<inlineCode parentName="p">{`ibm-aiops`}</inlineCode>{` Namespace.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <h2>{`Check with the Command Line`}</h2>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`oc get csv -n ibm-aiops                                                           
`}</code></pre>
        <br />
        <p>{`And you should see all entries with `}<inlineCode parentName="p">{`Succeeded`}</inlineCode>{` state (version numbers may vary)`}</p>
        <pre><code parentName="pre" {...{
            "className": "language-yaml"
          }}>{`NAME                                  DISPLAY                               VERSION   REPLACES                        PHASE
elasticsearch-operator.v5.7.6         OpenShift Elasticsearch Operator      5.7.6     elasticsearch-operator.v5.7.5   Succeeded
ibm-aiops-orchestrator.v4.x.x         IBM Cloud Pak for AIOps               4.x.x                                     Succeeded
ibm-common-service-operator.v3.23.8   IBM Cloud Pak foundational services   3.23.8                                    Succeeded
`}</code></pre>
        <br />
        <hr />
        <br />
        <h2>{`Check with your OpenShift Web Console`}</h2>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Go to Operators Installed Operators `}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`You should get something similar to this (version numbers may vary):`}</p>
            <img parentName="li" {...{
              "src": "./../images/53_operators_installed.png",
              "alt": "image"
            }}></img>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p><strong parentName="p">{`You have successfully finished this Chapter`}</strong></p>
      <p>{`You are now done with the chapter on Installing the Operator.`}</p>
      <p>{`Please continue to the next chapter to learn how to install CP4AIOPS.`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      